import React from 'react';
import { skipToMainContent } from './SkipNavUtils';

const SkipNavAnchor = (): JSX.Element => {
  return (
    <a className="usa-skipnav" href="#main-content" onClick={skipToMainContent}>
      Skip to main content
    </a>
  );
};

export default SkipNavAnchor;
